<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class InsurancePageMixin extends Vue {
        async loadRuntimeData() {
            const {locationId} = this.searchRequest
            if (insuranceRuntimeStore.location.id !== locationId) await insuranceRuntimeStore.loadLocation(locationId)
        }
    }

    export default InsurancePageMixin
</script>
